import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { bookFontStack } from './font-stack.js';
/**
 * Одна подсвеченная плашка на одну рассчитанную строку.
 * `nowrap` принципиален: переносы уже вычислены `book-schema`, браузер не имеет
 * права молча добавить девятую строку и рассогласовать превью с PDF.
 */
export function LineHighlightText({ text, highlightColor = 'rgba(255,255,255,.9)', textColor = '#4a3d52', align = 'left', fontFamily = 'Playpen Sans', fontSizePt = 14, style, }) {
    const lines = text.split('\n');
    const justifyContent = align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start';
    return (_jsx("div", { "data-line-highlight-text": "", style: { width: '100%', textAlign: align, ...style }, children: lines.map((line, index) => {
            const empty = line.length === 0;
            return (_jsx("div", { "data-text-line": "", "data-empty-text-line": empty ? '' : undefined, style: {
                    display: 'flex',
                    justifyContent,
                    marginBlockEnd: index < lines.length - 1 ? '.35em' : 0,
                    lineHeight: 0,
                }, children: _jsx("span", { "aria-hidden": empty ? true : undefined, style: {
                        display: 'inline-block',
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                        whiteSpace: 'nowrap',
                        backgroundColor: empty ? 'transparent' : highlightColor,
                        color: empty ? 'transparent' : textColor,
                        fontFamily: bookFontStack(fontFamily),
                        fontSize: `${fontSizePt}pt`,
                        fontWeight: 500,
                        lineHeight: 1.55,
                        padding: '.12em .08em',
                        borderRadius: '.25em',
                    }, children: empty ? '\u00a0' : line }) }, `${index}:${line}`));
        }) }));
}
//# sourceMappingURL=line-highlight-text.js.map